module.exports = __webpack_public_path__ + "static/media/background.b6f6851a.png";